import permissions from '@/constants/permissions'

const DonorContact = () => import('@/views/DonorContact.vue')

export default [
  {
    path: '/kontakt-wolontariusza-z-darczynca/:childEditionId',
    name: 'DonorContactAdd',
    component: DonorContact,
    props: true,
    meta: {
      requireAuth: true,
      permission: [permissions.contactWithGiftgiverAdd, permissions.assignedContactWithGiftgiverAdd]
    }
  },
  {
    path: '/kontakt-wolontariusza-z-darczynca/:childEditionId/:donorContactId',
    name: 'DonorContact',
    component: DonorContact,
    props: true,
    meta: {
      requireAuth: true,
      permission: [permissions.childEditionView, permissions.assignedChildEditionView]
    }
  }
]
